export default {
  payin: 'Поповнення',
  payoff: 'Нарахування',
  payout: 'Виплата',
  purchase: 'Купівля',
};
